module.exports = __webpack_public_path__ + "media/images/costumes/top/dress/thumbnail-2-1cb9313142b8dca3673f8f6e7aee046e.jpg";